import * as React from 'react'
import { Card, CardContent, CardMedia, CardActions } from '@mui/material';

export type Props = {
	id: string
	name: string
	src: string
	selected: boolean
	onSelect: Function
	onClose: Function
	className?: string
}

type State = { 
	elem: HTMLElement | null
}

export default class PatternBrowserItem extends React.Component<Props, State> {
	state:State = {
		elem: null
	};

	private onItemSelect = () => {
		this.props.onSelect();
	}

	render() {
		return <>
			<Card className={"condensed library-browser-item " + (this.props.className || '') + (this.props.selected ? ' selected ' : '')}>
				<CardContent onClick={this.onItemSelect}>
					<CardMedia image={this.props.src} />
				</CardContent>
				<CardActions>
					<h4>{this.props.name}</h4>
				</CardActions>
			</Card>
		</>
	}
}